import KPIReport from "./kpi-report";
export default KPIReport;